import { HighwaysDamageType } from '@highways/constants/damageTypes';
import { HighwaysType } from '@highways/store/storeSlices/highwaysDetails';

/**
 * Refer to https://wcc-dev-apim-external.developer.azure-api.net/api-details#api=wcc-highways-reports-api&operation=create&definition=HighwaysServiceDetailsType
 * @param issueType
 * @returns Highways issue type enum
 */
export const formatIssueType = (issueType: HighwaysType | null) => {
  switch (issueType) {
    case HighwaysType.Road:
      return 'RoadDamage';
    case HighwaysType.Pavement:
      return 'PavementDamage';
    default:
      return '';
  }
};

/**
 * Refer to https://wcc-dev-apim-external.developer.azure-api.net/api-details#api=wcc-highways-reports-api&operation=create&definition=HighwaysServiceDetailsType
 * @param issueDetails
 * @returns Highways issue details enum
 */
export const formatIssueDetails = (issueDetails: HighwaysDamageType | null) => {
  switch (issueDetails) {
    case HighwaysDamageType.Potholes:
      return 'Potholes';
    case HighwaysDamageType.UnevenSurfaces:
      return 'UnevenSurfaces';
    case HighwaysDamageType.ManholeCovers:
      return 'ManholeCovers';
    case HighwaysDamageType.RoadMarkings:
      return 'RoadMarkings';
    case HighwaysDamageType.BrickRoads:
      return 'BrickRoads';
    case HighwaysDamageType.Covers:
      return 'Covers';
    case HighwaysDamageType.PavingSlabs:
      return 'PavingSlabsOrStones';
    default:
      return '';
  }
};
